import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { doSendVerificationEmail } from '../actions';
import getattr from '../utils/getattr'
import { UserIsAuthenticated } from '../utils/auth'


class EmailVerification extends Component {

  sendVerificationEmail = () => {
    this.props.doSendVerificationEmail();
  };

  checkIsVerified = (auth) => {
    if(!auth.isLoading && auth.user && auth.user.verified) {
      this.props.push('/')
    }
  }
  componentWillReceiveProps(nextProps) {
    this.checkIsVerified(nextProps.auth)
  }
  componentWillMount() {
    this.checkIsVerified(this.props.auth)
  }

  render() {

    let sendCause = getattr(this.props, 'router', 'location', 'query', 'send') || getattr(this.props, 'router', 'params', 'cause') || 'again';

    let verificationSentClasses = 'verify-emailSent';
    let verificationSentMessage = '';
    if(this.props.email_verification.attempted) {
      verificationSentClasses += (this.props.email_verification.error) ? ' verify-emailSent-error' : '';
      verificationSentMessage = <div className={verificationSentClasses}>
        {this.props.email_verification.message}
      </div>;
    }

    return (
      <div className="pageContainer">
        <div className="staticCollageHolder">&nbsp;</div>
        <div className="page emailVerification">
          <h2 className="headline">
            Become a WorldWideWomen member!
            <small>
              Build your profile, tell us your interests & connect with amazing resources 
            </small>
          </h2>
          <div className="content-wrapper">
            {sendCause === 'required' ? (
              <div className="verify-message">
                <i className="fa fa-times-circle"></i> Please verify your email to access the page
              </div>
            ) : null}
            <div className="join-forms">

              <div className="verify-wrapper">
                <div className="verify">
                  <div className="verify-title">Time to check your email</div>
                  <img src="/images/others/girl-chair-laptop.png" />
                  <div className="verify-description">
                    <p> To finish activating your WorldWideWomen membership,
              click the link in the email we just sent to your email
                  address <em>{this.props.auth.user.email}</em>.</p>
                    <p>It won't take long. We'll wait right here for you.</p>
                  </div>
                  {verificationSentMessage}
                  <button onClick={this.sendVerificationEmail} className="button button-primary button-send">
                    {sendCause === 'expired' ? "My link has expired. Send Again." : "I did not receive the email. Send Again."}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default UserIsAuthenticated(connect(
  mapStateToProps,
  {
    push,
    doSendVerificationEmail
  }
)(EmailVerification));



// WEBPACK FOOTER //
// ./src/containers/EmailVerification.jsx